import Select from 'react-dropdown-select';
import calendaryIcon from './../../static/images/icon/calendaryIcon.svg'
import searchIcon from './../../static/images/icon/search-sm.svg'
import { optionsPeriod, optionsStatus } from '../../core/enum';

interface SearchFilterProps {
    onFilter: (nameFiler: string, valueFiler: string) => void
    dataOption?: string
}

const SearchFilterComponent = ({ onFilter, dataOption='out' }: SearchFilterProps) => {

    const selectedValuesPeriod: any[] = [];
    const selectedValuesStatus: any[] = [];
    
    return (
        <div className='flex flex-wrap flex-auto w-full gap-4 mb-6'>
            <div className="grow shrink-0 border border-gray-300 flex items-center px-4 h-12">
                <div className="flex w-full">
                    <img src={searchIcon} alt="" className="w-6 h-6" />
                    <input
                        type="search"
                        id="default-search"
                        className="block w-full text-sm text-gray-900 rounded-lg bg-gray-50 "
                        placeholder="Search: Name, ID"
                        onChange={(e: any) => onFilter('search', e.target.value)}
                    />
                </div>
            </div>
            <div className="grow shrink-0 border border-gray-300 flex items-center px-4 h-12">
                <div className="flex w-full">
                    <img src={calendaryIcon} alt="" className='pr-1' />
                    <div className='w-full py-4'>
                        <Select
                            options={optionsPeriod}
                            className="w-full h-full"
                            placeholder="Time Period: All Time"
                            values={optionsPeriod.filter((data: any) => selectedValuesPeriod.includes(data.label))}
                            onChange={(valueOprion: any[]) => {
                                selectedValuesPeriod.push(valueOprion[0].value)
                                onFilter('period', valueOprion[0].value)
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="grow shrink-0 border border-gray-300 flex items-center px-4 h-12">
                <div className="flex w-full">
                    <img src={calendaryIcon} alt="" className='pr-1' />
                    <div className='w-full py-4'>
                        <Select
                            options={optionsStatus[dataOption]}
                            className="w-full h-full"
                            placeholder="Status: All"
                            values={optionsStatus[dataOption].filter((data: any) => selectedValuesStatus.includes(data.label))}
                            onChange={(valueOprion: any[]) => {
                                selectedValuesStatus.push(valueOprion[0].value)
                                onFilter('status', valueOprion[0].value)
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchFilterComponent;